import React from "react";
import ReactDOM from "react-dom";
import RealtimeMarketReact from "./RealtimeMarket";

class RealtimeMarket extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `<div id="root"></div>`;

    ReactDOM.render(
      React.createElement(RealtimeMarketReact, { domainId: this.getAttribute("domain_id") }),
      this.querySelector("#root")
    );
  }
}

customElements.define("realtime-market-react", RealtimeMarket);
